// extracted by mini-css-extract-plugin
export var root = "License-module--root--q7V3N";